export default "__VITE_ASSET__f0a34b0a__"